import user from './api/user'
import orders from './api/orders'
import filters from './api/filters'
import messages from './api/messages'

const repositories = {
  user,
  orders,
  filters,
  messages
}

export const Repository = {
  call: name => repositories[name]
}



// WEBPACK FOOTER //
// ./src/repository/repository.js